import { cn } from '@scalis/utils'
import type { AvatarGroupProps } from '.'
import { Avatar, AvatarProps } from '../default'
import { getAvatarColor } from '../default/avatar.utils'
import { MAX_AVATARS, MIN_AVATARS } from './avatar-group.constants'

export const AvatarGroup = ({ avatars, maxAvatars, size, noReverse, noHorizontalSpacing }: AvatarGroupProps) => {
  const maxAvatarFallback = maxAvatars ?? MAX_AVATARS
  const hasOneAvatar = avatars.length === MIN_AVATARS

  const returnAvatars = (avatars: AvatarProps[], maxAvatars: number) => {
    const avatarsToDisplay = avatars.slice(0, maxAvatars)
    const hasMoreMaxAvatars = avatars.length > maxAvatars
    const remainingAvatars = avatars.length - maxAvatars

    const avatarElements = avatarsToDisplay.map((avatar) => (
      <Avatar
        key={avatar.id}
        {...avatar}
        size={size}
        backgroundColor={getAvatarColor(avatar.fullName ?? '')}
        className='group-hover:after:bg-black/[0.04] group-active:after:bg-black/[0.08]'
      />
    ))

    if (hasMoreMaxAvatars) {
      const hasMoreAvatarsElement = (
        <Avatar
          className='group-hover:after:bg-black/[0.04] group-active:after:bg-black/[0.08]'
          size={size}
          key='at-end-avatar'
          fullName={`+${remainingAvatars}`}
          atEnd
        />
      )

      if (noReverse) {
        avatarElements.push(hasMoreAvatarsElement)
      } else {
        avatarElements.unshift(hasMoreAvatarsElement)
      }
    }

    return (
      <div
        className={cn('group flex -space-x-2', {
          'flex-row-reverse space-x-reverse': !noReverse,
          'px-1': !noHorizontalSpacing,
        })}
      >
        {avatarElements}
      </div>
    )
  }

  if (hasOneAvatar)
    return (
      <Avatar
        {...avatars[0]}
        size={size}
        displayFullName={true}
      />
    )

  return returnAvatars(avatars, maxAvatarFallback)
}
